export enum OrganizationSettingsView {
	General = 'general',
	Members = 'members',
	Authentication = 'authentication',
	User = 'user',
	Funds = 'funds',
	FundDeals = 'fund-deals',
	ProgrammeDefaults = 'programme-defaults',
	ProgrammeDefaultsMembers = 'programme-defaults-members',
	ProgrammeDefaultsKycSettings = 'programme-defaults-kyc-settings',
	ProgrammeDefaultsInvestorData = 'programme-defaults-investor-data',
	ProgrammeDefaultsVestingTerms = 'programme-defaults-vesting-terms',
	ProgrammeDefaultsMasterDocuments = 'programme-defaults-master-documents',
	ProgrammeDefaultsTaxAndCompliance = 'programme-defaults-tax-and-compliance',
	ProgrammeDefaultsEmailTemplates = 'programme-defaults-email-templates',
	ProgrammeDefaultsEmailReminders = 'programme-defaults-email-reminders',
	DealDefaults = 'deal-defaults',
	DealDefaultsMembers = 'deal-defaults-members',
	DealDefaultsClassifiers = 'deal-defaults-classifiers',
	DealDefaultsEmailTemplates = 'deal-defaults-email-templates',
}
